// extracted by mini-css-extract-plugin
export default {"versionCardBody":"versionCardBody---Cl_av","changedRecordsList":"changedRecordsList---znE0L","changedRecord":"changedRecord---T5i7b"};